module.exports = __webpack_public_path__ + "static/media/iconCoursesLive.27e4817a.svg";